<template>
  <section>
    <div class="search-content">
      <el-row :gutter="20">
        <el-col :span="14">
          <el-button class="search-btn" size="small" type="main" icon="el-icon-plus" @click="handleAddNotify">新增</el-button>
          <el-button class="search-btn" size="small" type="danger" icon="el-icon-delete-solid" @click="handleBatchDelete">删除</el-button>
        </el-col>
        <el-col :span="10" style="text-align: right;">
          <el-input class="search-input" size="small" placeholder="请输入标题" v-model="searchInfo.title"></el-input>
          <el-button class="search-btn" size="small" type="main" icon="el-icon-search" @click="handleSearch">搜索</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="table-content">
      <el-table
        :data="tableData"
        v-loading="loading"
        @selection-change="handleSelectionChange"
        border
        style="width: 100%;margin-top:20px">
        <el-table-column
          type="selection"
          width="40">
        </el-table-column>
        <el-table-column
          prop="title"
          label="标题">
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          width="200">
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="main" size="mini" icon="el-icon-edit-outline" @click="handleEditNotify(scope.$index, scope.row)">编辑</el-button>
            <el-button type="danger" size="mini" icon="el-icon-delete-solid" @click="handleDel(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="table-page"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageInfo.total">
      </el-pagination>
    </div>
  </section>
</template>
<script>
  import Common from '@/components/common/Common'
  import { Table } from '@/components/common/Table'
  import { listNotifyFile, batchDeleteNotifyFile, deleteNotifyFile } from '@/api/restapi.js'
  export default {
    mixins: [Table],
    data() {
      return {
        user: Common.user
      }
    },
    mounted () {
    },
    methods: {
      searchMethod () {
        return listNotifyFile(this.pageInfo.page,this.pageInfo.size, this.searchInfo)
      },
      handleAddNotify () {
        this.$router.push('/notifyFileDetail')
      },
      handleEditNotify (col, row) {
        this.$router.push('/notifyFileDetail?id='+row.id)
      },
      deleteMethod (id) {
        return deleteNotifyFile(id)
      },
      batchDeleteMethod () {
        return batchDeleteNotifyFile(this.selectIds)
      }
    }
  }
</script>
<style scoped>
  @import "../style/Table.css";
</style>



// WEBPACK FOOTER //
// src/components/NotifyFile.vue